// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__2gEKX","description":"style_description__e2CZ6"};